import { Component, OnInit,Input, EventEmitter, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { KmsEnum } from 'src/app/areas/kms/serves/kms-enum';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $;
@Component({
  selector: 'app-rel-addorupdate',
  templateUrl: './rel-addorupdate.component.html',
  styleUrls: ['./rel-addorupdate.component.css']
})
export class RelAddorupdateComponent implements OnInit {
  //接收父组件的数据  
  @Input() addOrUpdate:string;              // 操作类型
  @Input() id:any;                       // 属性主键id（自增长id）
  @Input() modelVerId:string;              // 模型版本id
  onlyEditName:boolean = true;
  // 新增或编辑操作成功后向父组件发射数据
  @Output('relSave') relSave = new EventEmitter<any>();  
  // 取消操作成功后向父组件发射数据
  @Output('relCancel') relCancel = new EventEmitter<any>();  
 
  formModel:any = {}; // 表单信息
  ontologyTreeDatas:any = [];  // 概念树数据
  readonlySelfIds:any = [];    // 不可选择的概念节点
  relTypeOptions:any = [];
  RelTypeCode = KmsEnum.KGS_RELATION_TYPE;

  constructor(
    private dicService: DictionaryService,
    private kmsService: KmsService,
    private message: SwMassageBoxService,
    private swMaskService: SwMaskService
  ) { }

  ngOnInit() {
    this.relTypeOptions = this.dicService.getDictionaryTree(this.RelTypeCode,'dictionaryId','dictionaryName','parentId','dictionaryValue');
    let options = JSON.parse(JSON.stringify(this.relTypeOptions));
    this.relTypeOptions.forEach(element => {
        let item = options.filter(el => el.id == element['pid']);
        element['pid'] = item.length>0 ? item[0].value : '0';
        element['parentId'] = element['pid'];
        element['id'] = element['value'];
    });
    console.log(this.relTypeOptions);
  }

  ngOnChanges() {
    this.getOnlogyTreePageList();
    if(this.addOrUpdate == 'editRel'){
      // 根据主键查询概念关系信息
      this.kmsService.getConceptRelationById(this.id).subscribe(
        result => {
            if (result.code == 200) {
              let res = result.data;
              this.formModel = {
                conceptRelationshipId: res.conceptRelationship.conceptRelationshipId,
                sourceConceptId: res.conceptRelationship.sourceConceptId,
                sourceConceptName: res.conceptRelationship.sourceConceptName,
                targetConceptId: res.conceptRelationship.targetConceptId,
                targetConceptName: res.conceptRelationship.targetConceptName,
                id: res.id,
                relationshipId: res.relationshipId,
                relationName: res.relationName,
                relationAlias: res.relationAlias,
                reverseRelationAlias: res.reverseRelationAlias,
                reverseRelationName: res.reverseRelationName,
                relationType: res.relationType,
                sortNum: res.sortNum
              }
            }
        }
      )
    }else{
      this.formModel = {};
    }
  }

  // 请求概念数据模型方法
  getOnlogyTreePageList() {
    this.ontologyTreeDatas = [];
    this.kmsService.getConceptTree(this.modelVerId).subscribe(
        result => {
            if (result.code == 200) {
                if (!result.data) {
                    this.ontologyTreeDatas = [];
                    return;
                }
                let datas = result.data;
                this.ontologyTreeDatas = datas;
                this.readonlySelfIds = datas.length>0 ? [datas[0].id] : [];
            } else {
                this.message.waring(result.msg);
            }
        }
    )
  }

  // 关系编辑-切换起始或指向子概念
  conceptChange(state, event) {
      if (state == 'source') {
          this.formModel.sourceConceptId = event.id;
          this.formModel.sourceConceptName = event.text;
      } else {
          this.formModel.targetConceptId = event.id;
          this.formModel.targetConceptName = event.text;
      }
  }

  // 关系编辑-清除起始或指向子概念
  clearConcept(state, event) {
    if (state == 'source') {
        this.formModel.sourceConceptId = '';
        this.formModel.sourceConceptName = '';
    } else {
        this.formModel.targetConceptId = '';
        this.formModel.targetConceptName = '';
    }
  }

  // 表单提交方法
  onSubmit() {
    console.log(this.formModel)
    if(!$.trim(this.formModel.relationAlias) && !$.trim(this.formModel.reverseRelationAlias)){
      this.message.info("请录入关系别名！");
      return;
    }
    this.swMaskService.openMask("数据正在保存,请稍等...");
    // 判断是否为重命名操作
    if(this.addOrUpdate == 'editRel' && this.onlyEditName){
      let params = {
        "id":this.formModel.id,
        "relationName": $.trim(this.formModel.relationName),
        "relationAlias": $.trim(this.formModel.relationAlias),
        "reverseRelationAlias": $.trim(this.formModel.reverseRelationAlias),
        "reverseRelationName": $.trim(this.formModel.reverseRelationName)
      }
      this.kmsService.updateRelationName(params).subscribe(
          result => {
              this.swMaskService.closeMask();
              if (result.code == 200) {
                this.message.success('操作成功！');
                // 当前为重命名操作才发射true,父元素接收到后将不会刷新模型树，只更新模型可视化组件
                this.relSave.emit(true);
              } else {
                this.message.waring(result.msg);
              }
          }
      )
    }
    // 新增、编辑属性操作
    else{
      // 保存关系信息
      let params = {
          "conceptRelationship": {
              "conceptRelationshipId": this.formModel.conceptRelationshipId,
              "sourceConceptId": this.formModel.sourceConceptId,
              "sourceConceptName": this.formModel.sourceConceptName,
              "targetConceptId": this.formModel.targetConceptId,
              "targetConceptName": this.formModel.targetConceptName,
              "modelVerId": this.modelVerId,
          },
          "conceptRelationshipId": this.formModel.conceptRelationshipId,
          "id": this.formModel.id,
          "relationshipId": this.formModel.relationshipId,
          "relationName": $.trim(this.formModel.relationName),
          "relationAlias": $.trim(this.formModel.relationAlias),
          "reverseRelationAlias": $.trim(this.formModel.reverseRelationAlias),
          "reverseRelationName": $.trim(this.formModel.reverseRelationName),
          "relationType": this.formModel.relationType,
          "sortNum": this.formModel.sortNum,
          "modelVerId": this.modelVerId
      }
      let func = this.addOrUpdate == 'addRel' ? this.kmsService.saveRelationship(params) : this.kmsService.updateRelationship(params);
      func.subscribe(
          data => {
            this.swMaskService.closeMask();
            if (data.code == '200') {
              this.message.success('操作成功！');
              this.relSave.emit(false);
            } else {
                this.message.waring(data.msg);
            }
          }
      )
    }
  }

  // 取消新增或编辑操作
  cancel(){
    this.relCancel.emit(true);
  }
}
